export default "/a5b48e0946994335e17e220415b7ad8a9ff4e295/20e765fe22790b7f1075e229233d4cab.svg";